import Navbar from "../Header.js/NavBar";
export default function Error(){
    return (
        <div>
        <Navbar></Navbar>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        
        <h1>404</h1>
        <h2>Page Not Found</h2>
        </div>
    );
}